import R from 'ramda';
import actionTypes from '../actionTypes';

const initialState = {
  works: [],
  userWorks: [],
  selectedWork: null,
};

export default (state = initialState, action) => {
  let index, workId;

  switch (action.type) {
    case actionTypes.USER_WORKS_GET_REQUEST:
    case actionTypes.WORK_GET_REQUEST:
    case actionTypes.WORK_CREATE_REQUEST:
    case actionTypes.WORK_UPDATE_REQUEST:
      return { ...state, status: action.type };

    case actionTypes.WORKS_GET_REQUEST:
      return {
        ...state,
        status: action.type,
        works: null,
      };

    case actionTypes.WORKS_GET_ERROR:
      return { ...state, status: action.type, works: [] };

    case actionTypes.USER_WORKS_GET_SUCCESS:
      return { ...state, status: action.type, userWorks: action.works };

    case actionTypes.USER_WORKS_GET_ERROR:
      return { ...state, status: action.type, userWorks: [] };

    case actionTypes.WORK_GET_ERROR:
    case actionTypes.WORK_CREATE_ERROR:
      return {
        ...state,
        status: action.type,
        error: action.error,
        selectedWork: null,
      };

    case actionTypes.WORK_GET_SUCCESS:
    case actionTypes.WORK_SELECT:
      return { ...state, status: action.type, selectedWork: action.work };

    case actionTypes.WORK_CREATE_SUCCESS:
      return {
        ...state,
        status: action.type,
        selectedWork: action.work,
        works: state.works.concat(action.work),
      };

    case actionTypes.WORK_UPDATE_SUCCESS:
      index = R.findIndex(R.propEq('id', action.work.id))(state.works);
      if (index === -1) {
        return {
          ...state,
          status: action.type,
          selectedWork: action.work,
          works: state.works.concat(action.work),
        };
      } else {
        state.works[index] = {
          ...action.work,
          work_ownership_info: state.works[index].work_ownership_info,
        };
        return {
          ...state,
          status: action.type,
          selectedWork: action.work,
          works: [...state.works],
        };
      }

    case actionTypes.WORK_DELETE_SUCCESS:
      index = R.findIndex(R.propEq('id', parseInt(action.workId, 10)))(
        state.works
      );
      if (index !== -1) {
        return {
          ...state,
          status: action.type,
          selectedWork: null,
          works: R.remove(index, 1, state.works),
        };
      } else {
        return { ...state, status: action.type, selectedWork: null };
      }

    case actionTypes.WORK_OWNERSHIP_CREATE_SUCCESS:
      if (action.workOwnership) {
        workId = action.workOwnership.work;
        index = R.findIndex(R.propEq('id', workId))(state.works);
        if (index !== -1) {
          const ownerships = state.works[index].work_ownership_info || [];
          const index2 = R.findIndex(R.propEq('id', action.workOwnership.id))(
            ownerships
          );
          if (index2 === -1) {
            state.works[index].work_ownership_info = [
              ...ownerships,
              action.workOwnership,
            ];
          }
          return { ...state, status: action.type, works: [...state.works] };
        }
      }
      return state;

    case actionTypes.WORK_OWNERSHIP_UPDATE_SUCCESS:
      if (action.workOwnership) {
        workId = action.workOwnership.work;
        index = R.findIndex(R.propEq('id', parseInt(workId, 10)))(state.works);
        if (index !== -1) {
          const index2 = R.findIndex(
            R.propEq('id', parseInt(action.workOwnership.id, 10))
          )(state.works[index].work_ownership_info || []);
          if (index2 !== -1) {
            state.works[index].work_ownership_info[index2] =
              action.workOwnership;
          }
          return { ...state, status: action.type, works: [...state.works] };
        }
      }
      return state;

    case actionTypes.WORK_OWNERSHIP_DELETE_SUCCESS:
      if (action.workOwnership) {
        workId = action.workOwnership.work;
        index = R.findIndex(R.propEq('id', workId))(state.works);
        if (index !== -1) {
          const index2 = R.findIndex(R.propEq('id', action.workOwnership.id))(
            state.works[index].work_ownership_info || []
          );
          if (index2 !== -1) {
            state.works[index].work_ownership_info = R.remove(
              index2,
              1,
              state.works[index].work_ownership_info
            );
          }
          return { ...state, status: action.type, works: [...state.works] };
        }
      }
      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// src/redux/reducers/works.js